import React from 'react';
import styled from 'styled-components';

interface svgProps {
  color?: string;
  width?: string;
  height?: string;
  strokeWidth?: string;
  stroke?: string;
  className?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  tooltip?: string;
}
const SvgWrapper = styled('svg')({});

const FaciltyIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '18'}
      height={height ? height : '19'}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.2716 0.247048C8.48256 0.0865735 8.73775 0 8.99982 0C9.26189 0 9.51709 0.0865735 9.72804 0.247048L17.4987 6.16223C18.4184 6.8631 17.988 8.33916 16.8933 8.44218H1.10638C0.0115937 8.33916 -0.417976 6.8631 0.500893 6.16223L8.2716 0.247048ZM8.99982 5.90975C9.32533 5.90975 9.63751 5.7763 9.86768 5.53876C10.0979 5.30122 10.2272 4.97905 10.2272 4.64312C10.2272 4.30718 10.0979 3.98501 9.86768 3.74747C9.63751 3.50993 9.32533 3.37648 8.99982 3.37648C8.67431 3.37648 8.36213 3.50993 8.13196 3.74747C7.90179 3.98501 7.77248 4.30718 7.77248 4.64312C7.77248 4.97905 7.90179 5.30122 8.13196 5.53876C8.36213 5.7763 8.67431 5.90975 8.99982 5.90975ZM13.5001 9.28744H15.5448V14.354H13.4993L13.5001 9.28744ZM11.8636 14.354V9.28744H9.81805V14.354H11.8636ZM8.18159 14.3548V9.28829H6.13602V14.3548H8.18159ZM4.50039 14.3548V9.28829H2.45482V14.3548H4.50039ZM2.65938 15.1993C1.9541 15.1993 1.27772 15.4884 0.779011 16.0031C0.280308 16.5177 0.000138405 17.2158 0.000138405 17.9436V18.3658C3.08619e-05 18.4491 0.0158247 18.5315 0.0466164 18.6085C0.077408 18.6854 0.122593 18.7553 0.179589 18.8142C0.236584 18.8731 0.304271 18.9198 0.378778 18.9517C0.453286 18.9836 0.533152 19 0.613809 19H17.385C17.5478 19 17.7039 18.9333 17.8189 18.8145C17.934 18.6957 17.9987 18.5346 17.9987 18.3667V17.9445C17.9987 17.2166 17.7185 16.5186 17.2198 16.0039C16.7211 15.4892 16.0447 15.2001 15.3394 15.2001L2.65938 15.1993Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const LoanIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '20'}
      height={height ? height : '16'}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 2C5 1.46957 5.21071 0.960859 5.58579 0.585786C5.96086 0.210714 6.46957 0 7 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2V9C20 9.53043 19.7893 10.0391 19.4142 10.4142C19.0391 10.7893 18.5304 11 18 11H16V7C16 6.20435 15.6839 5.44129 15.1213 4.87868C14.5587 4.31607 13.7956 4 13 4H5V2Z"
        fill="#474747"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 7C0 6.46957 0.210714 5.96086 0.585786 5.58579C0.960859 5.21071 1.46957 5 2 5H13C13.5304 5 14.0391 5.21071 14.4142 5.58579C14.7893 5.96086 15 6.46957 15 7V14C15 14.5304 14.7893 15.0391 14.4142 15.4142C14.0391 15.7893 13.5304 16 13 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V7ZM7.5 8C6.83696 8 6.20107 8.26339 5.73223 8.73223C5.26339 9.20107 5 9.83696 5 10.5C5 11.163 5.26339 11.7989 5.73223 12.2678C6.20107 12.7366 6.83696 13 7.5 13C8.16304 13 8.79893 12.7366 9.26777 12.2678C9.73661 11.7989 10 11.163 10 10.5C10 9.83696 9.73661 9.20107 9.26777 8.73223C8.79893 8.26339 8.16304 8 7.5 8Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const LOCIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '14'}
      height={height ? height : '18'}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.16665 0.666672C0.945633 0.666672 0.733671 0.754469 0.577391 0.910749C0.421111 1.06703 0.333313 1.27899 0.333313 1.50001V14.8333C0.333313 15.4964 0.596705 16.1323 1.06555 16.6011C1.53439 17.0699 2.17027 17.3333 2.83331 17.3333H11.1666C11.8297 17.3333 12.4656 17.0699 12.9344 16.6011C13.4033 16.1323 13.6666 15.4964 13.6666 14.8333V5.66667C13.6666 5.44568 13.5788 5.23375 13.4225 5.07751L9.25581 0.910838C9.09957 0.754547 8.88764 0.666719 8.66665 0.666672H1.16665ZM8.66665 2.67834L11.655 5.66667H8.66665V2.67834ZM3.66665 9.83334C3.66665 9.61232 3.75444 9.40036 3.91072 9.24408C4.067 9.0878 4.27897 9 4.49998 9H9.49998C9.72099 9 9.93295 9.0878 10.0892 9.24408C10.2455 9.40036 10.3333 9.61232 10.3333 9.83334C10.3333 10.0544 10.2455 10.2663 10.0892 10.4226C9.93295 10.5789 9.72099 10.6667 9.49998 10.6667H4.49998C4.27897 10.6667 4.067 10.5789 3.91072 10.4226C3.75444 10.2663 3.66665 10.0544 3.66665 9.83334ZM3.66665 13.1667C3.66665 12.9457 3.75444 12.7337 3.91072 12.5774C4.067 12.4211 4.27897 12.3333 4.49998 12.3333H9.49998C9.72099 12.3333 9.93295 12.4211 10.0892 12.5774C10.2455 12.7337 10.3333 12.9457 10.3333 13.1667C10.3333 13.3877 10.2455 13.5996 10.0892 13.7559C9.93295 13.9122 9.72099 14 9.49998 14H4.49998C4.27897 14 4.067 13.9122 3.91072 13.7559C3.75444 13.5996 3.66665 13.3877 3.66665 13.1667Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const RateIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '20'}
      height={height ? height : '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 13.6877C20 11.9449 19.2671 10.3672 18.0826 9.22434C16.898 8.08215 15.2611 7.37546 13.4537 7.37546C11.6463 7.37546 10.0092 8.08215 8.82479 9.22434C7.64041 10.3665 6.90735 11.945 6.90735 13.6877C6.90735 15.4313 7.64024 17.0091 8.82479 18.1511C10.0093 19.2932 11.6463 20 13.4537 20C15.2611 20 16.8973 19.2933 18.0826 18.1511C19.2671 17.0089 20 15.4305 20 13.6877ZM10.115 2.49159C11.0696 3.32191 11.7123 4.47846 11.8504 5.77864C11.8843 6.09928 12.1821 6.33379 12.5147 6.30028C12.8472 6.26758 13.0896 5.98044 13.0557 5.6598C12.8852 4.06138 12.0969 2.64003 10.9264 1.62235C9.76666 0.614163 8.23067 0 6.54632 0C4.7389 0 3.10266 0.706681 1.91743 1.84888C0.732885 2.99108 0 4.56951 0 6.31227C0 7.81817 0.549266 9.20196 1.46496 10.2899C2.3972 11.3954 3.70921 12.1914 5.20975 12.4913C5.53732 12.5567 5.85827 12.3541 5.9261 12.0382C5.99392 11.7223 5.78382 11.4129 5.45624 11.3467C4.23366 11.1026 3.16414 10.4533 2.40476 9.55282C1.66112 8.66987 1.21526 7.54282 1.21526 6.31294C1.21526 4.89398 1.81166 3.60824 2.77699 2.67816C3.74233 1.74734 5.07418 1.17305 6.54656 1.17305C7.9197 1.17305 9.17134 1.67315 10.1152 2.4931L10.115 2.49159ZM9.54753 6.69014C9.78411 6.46202 9.78411 6.09033 9.54753 5.86221L6.97569 3.38233C6.73828 3.15341 6.35364 3.15341 6.11624 3.38233L3.5444 5.86221C3.30782 6.09033 3.30782 6.46202 3.5444 6.69014C3.7818 6.91906 4.16644 6.91906 4.40385 6.69014L5.93829 5.21056V8.82779C5.93829 9.15161 6.21045 9.41324 6.54545 9.41324C6.88129 9.41324 7.15344 9.15082 7.15344 8.82779V5.21056L8.68789 6.69014C8.92529 6.91906 9.31012 6.91906 9.54753 6.69014ZM12.8455 11.1727C12.8455 10.8489 13.1177 10.5873 13.4535 10.5873C13.7893 10.5873 14.0606 10.8497 14.0606 11.1727V14.7899L15.5951 13.3104C15.8325 13.0815 16.2171 13.0815 16.4545 13.3104C16.6911 13.5385 16.6911 13.9102 16.4545 14.1383L13.8827 16.6182C13.6453 16.8471 13.2607 16.8471 13.0233 16.6182L10.4514 14.1383C10.2148 13.9102 10.2148 13.5385 10.4514 13.3104C10.6888 13.0815 11.0735 13.0815 11.3109 13.3104L12.8453 14.7899L12.8455 11.1727Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const DashboardIcon = ({ width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '18'}
      height={height ? height : '18'}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.2462 3.51V6.42C8.2462 6.66095 8.19862 6.89953 8.10619 7.12205C8.01375 7.34456 7.87828 7.54663 7.70756 7.71666C7.53683 7.88669 7.33421 8.02133 7.11132 8.11286C6.88842 8.20438 6.64965 8.25099 6.4087 8.25H3.5137C3.2734 8.25146 3.03528 8.20438 2.81362 8.11159C2.59195 8.0188 2.3913 7.88221 2.2237 7.71C2.05354 7.54125 1.91878 7.34022 1.82734 7.11871C1.7359 6.89719 1.68962 6.65964 1.6912 6.42V3.5175C1.6912 3.03345 1.88297 2.56912 2.22454 2.22614C2.56611 1.88316 3.02966 1.68948 3.5137 1.6875H6.4162C6.65625 1.68773 6.89387 1.73558 7.1153 1.82827C7.33673 1.92096 7.53757 2.05666 7.7062 2.2275C7.87682 2.39474 8.01244 2.59427 8.10515 2.81446C8.19786 3.03465 8.24581 3.27109 8.2462 3.51ZM16.3087 3.5175V6.42C16.3048 6.90285 16.1118 7.36493 15.771 7.70707C15.4303 8.0492 14.969 8.24413 14.4862 8.25H11.5762C11.0911 8.24703 10.626 8.05616 10.2787 7.7175C10.109 7.54687 9.97459 7.34443 9.88322 7.12179C9.79184 6.89914 9.74528 6.66066 9.7462 6.42V3.5175C9.7456 3.27733 9.79306 3.03946 9.8858 2.81791C9.97854 2.59637 10.1147 2.39562 10.2862 2.2275C10.4548 2.05666 10.6557 1.92096 10.8771 1.82827C11.0985 1.73558 11.3362 1.68773 11.5762 1.6875H14.4787C14.9628 1.69142 15.426 1.88548 15.7684 2.22783C16.1107 2.57017 16.3048 3.03337 16.3087 3.5175ZM16.3087 11.58V14.4825C16.3048 14.9653 16.1118 15.4274 15.771 15.7696C15.4303 16.1117 14.969 16.3066 14.4862 16.3125H11.5762C11.088 16.3175 10.6171 16.1318 10.2637 15.795C10.0933 15.6249 9.95848 15.4225 9.86706 15.1998C9.77564 14.977 9.72946 14.7383 9.7312 14.4975V11.595C9.7306 11.3548 9.77806 11.117 9.8708 10.8954C9.96354 10.6739 10.0997 10.4731 10.2712 10.305C10.4398 10.1342 10.6407 9.99846 10.8621 9.90577C11.0835 9.81308 11.3212 9.76523 11.5612 9.765H14.4637C14.9478 9.76892 15.411 9.96298 15.7534 10.3053C16.0957 10.6477 16.2898 11.1109 16.2937 11.595L16.3087 11.58ZM8.2462 11.5875V14.49C8.2403 14.9741 8.04434 15.4365 7.70059 15.7775C7.35684 16.1184 6.89285 16.3106 6.4087 16.3125H3.5137C3.27409 16.3135 3.03665 16.267 2.81509 16.1758C2.59352 16.0846 2.39222 15.9503 2.22279 15.7809C2.05335 15.6115 1.91915 15.4102 1.82791 15.1886C1.73667 14.967 1.69021 14.7296 1.6912 14.49V11.5875C1.69313 11.1033 1.8853 10.6394 2.22624 10.2956C2.56718 9.95186 3.02958 9.7559 3.5137 9.75H6.4162C6.90235 9.75497 7.36757 9.94859 7.7137 10.29C8.05577 10.6351 8.24723 11.1016 8.2462 11.5875Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const UserIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '19'}
      height={height ? height : '15'}
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1261 10.9365C18.2033 10.5234 18.2033 10.1016 18.1261 9.68848L18.8921 9.25195C18.9812 9.20215 19.0198 9.09961 18.9901 9.00293C18.7912 8.37012 18.4498 7.7959 18.0044 7.32129C17.9361 7.24805 17.8263 7.23047 17.7372 7.28027L16.9712 7.7168C16.6475 7.44434 16.2764 7.2334 15.8756 7.09277V6.21973C15.8756 6.12012 15.8043 6.03223 15.7063 6.01172C15.0442 5.86523 14.3703 5.87109 13.7408 6.01172C13.6428 6.03223 13.5716 6.12012 13.5716 6.21973V7.09277C13.1708 7.2334 12.7996 7.44434 12.476 7.7168L11.71 7.28027C11.6239 7.23047 11.5111 7.24805 11.4428 7.32129C10.9974 7.7959 10.656 8.37012 10.457 9.00293C10.4274 9.09961 10.4689 9.20215 10.555 9.25195L11.321 9.68848C11.2438 10.1016 11.2438 10.5234 11.321 10.9365L10.555 11.373C10.4659 11.4229 10.4274 11.5254 10.457 11.6221C10.656 12.2549 10.9974 12.8262 11.4428 13.3037C11.5111 13.377 11.6209 13.3945 11.71 13.3447L12.476 12.9082C12.7996 13.1807 13.1708 13.3916 13.5716 13.5322V14.4053C13.5716 14.5049 13.6428 14.5928 13.7408 14.6133C14.4029 14.7598 15.0769 14.7539 15.7063 14.6133C15.8043 14.5928 15.8756 14.5049 15.8756 14.4053V13.5322C16.2764 13.3916 16.6475 13.1807 16.9712 12.9082L17.7372 13.3447C17.8233 13.3945 17.9361 13.377 18.0044 13.3037C18.4498 12.8291 18.7912 12.2549 18.9901 11.6221C19.0198 11.5254 18.9783 11.4229 18.8921 11.373L18.1261 10.9365ZM14.7266 11.7334C13.9308 11.7334 13.2866 11.0947 13.2866 10.3125C13.2866 9.53027 13.9338 8.8916 14.7266 8.8916C15.5193 8.8916 16.1665 9.53027 16.1665 10.3125C16.1665 11.0947 15.5223 11.7334 14.7266 11.7334ZM6.6507 7.5C8.74983 7.5 10.4511 5.82129 10.4511 3.75C10.4511 1.67871 8.74983 0 6.6507 0C4.55157 0 2.8503 1.67871 2.8503 3.75C2.8503 5.82129 4.55157 7.5 6.6507 7.5ZM12.6245 14.1357C12.5562 14.1006 12.4879 14.0596 12.4226 14.0215L12.188 14.1562C12.0099 14.2559 11.808 14.3115 11.6061 14.3115C11.2824 14.3115 10.9707 14.1768 10.748 13.9424C10.2047 13.3623 9.789 12.6562 9.55444 11.9033C9.39115 11.3848 9.61086 10.8369 10.0859 10.5645L10.3205 10.4297C10.3175 10.3535 10.3175 10.2773 10.3205 10.2012L10.0859 10.0664C9.61086 9.79688 9.39115 9.24609 9.55444 8.72754C9.58117 8.64258 9.61976 8.55762 9.64946 8.47266C9.53663 8.46387 9.42677 8.4375 9.31098 8.4375H8.81515C8.15602 8.73633 7.42266 8.90625 6.6507 8.90625C5.87875 8.90625 5.14836 8.73633 4.48625 8.4375H3.99042C1.78738 8.4375 0 10.2012 0 12.375V13.5938C0 14.3701 0.638349 15 1.42515 15H11.8763C12.1761 15 12.4552 14.9062 12.6838 14.751C12.6482 14.6396 12.6245 14.5254 12.6245 14.4053V14.1357Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const MasterDataIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '18'}
      height={height ? height : '17'}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12.1569L0 1.15692L5.5 6.15692L9 0.156921L12.5 6.15692L18 1.15692L16 12.1569H2ZM16 15.1569C16 15.7569 15.6 16.1569 15 16.1569H3C2.4 16.1569 2 15.7569 2 15.1569V14.1569H16V15.1569Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const NavNotificationIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '26'}
      height={height ? height : '26'}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0217 3.1525C9.43587 3.1525 6.5217 6.06667 6.5217 9.6525V12.7833C6.5217 13.4442 6.24003 14.4517 5.9042 15.015L4.65837 17.0842C3.8892 18.3625 4.42003 19.7817 5.82837 20.2583C10.4975 21.8183 15.535 21.8183 20.2042 20.2583C21.515 19.825 22.0892 18.2758 21.3742 17.0842L20.1284 15.015C19.8034 14.4517 19.5217 13.4442 19.5217 12.7833V9.6525C19.5217 6.0775 16.5967 3.1525 13.0217 3.1525Z"
        stroke="#101317"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M15.0258 3.46667C14.69 3.36917 14.3433 3.29334 13.9858 3.25C12.9458 3.12 11.9491 3.19584 11.0175 3.46667C11.3316 2.665 12.1116 2.10167 13.0216 2.10167C13.9316 2.10167 14.7116 2.665 15.0258 3.46667Z"
        stroke="#101317"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.2717 20.6483C16.2717 22.4358 14.8092 23.8983 13.0217 23.8983C12.1333 23.8983 11.31 23.53 10.725 22.945C10.14 22.36 9.77167 21.5367 9.77167 20.6483"
        stroke="#101317"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </SvgWrapper>
  );
};

const LogOutIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '18'}
      height={height ? height : '20'}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.796 0.244C9.653 -0.174 11 1.422 11 3V17C11 18.578 9.653 20.174 7.796 19.756C3.334 18.752 0 14.766 0 10C0 5.234 3.334 1.248 7.796 0.244ZM13.293 6.293C13.4805 6.10553 13.7348 6.00021 14 6.00021C14.2652 6.00021 14.5195 6.10553 14.707 6.293L17.707 9.293C17.8945 9.48053 17.9998 9.73484 17.9998 10C17.9998 10.2652 17.8945 10.5195 17.707 10.707L14.707 13.707C14.5184 13.8892 14.2658 13.99 14.0036 13.9877C13.7414 13.9854 13.4906 13.8802 13.3052 13.6948C13.1198 13.5094 13.0146 13.2586 13.0123 12.9964C13.01 12.7342 13.1108 12.4816 13.293 12.293L14.586 11H6C5.73478 11 5.48043 10.8946 5.29289 10.7071C5.10536 10.5196 5 10.2652 5 10C5 9.73478 5.10536 9.48043 5.29289 9.29289C5.48043 9.10536 5.73478 9 6 9H14.586L13.293 7.707C13.1055 7.51947 13.0002 7.26516 13.0002 7C13.0002 6.73484 13.1055 6.48053 13.293 6.293Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const MISPortalIcon = ({ width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '16'}
      height={height ? height : '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1693_12060)">
        <path
          d="M13 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V3C15 1.89543 14.1046 1 13 1Z"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 12V7"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 12V4"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 12V10"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 8V12"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 9V12"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1693_12060">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgWrapper>
  );
};
const DataUploadIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 16V7.85L8.4 10.45L7 9L12 4L17 9L15.6 10.45L13 7.85V16H11ZM6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.19667 19.0217 4.00067 18.5507 4 18V15H6V18H18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.0217 19.805 18.5507 20.0007 18 20H6Z"
        fill="black"
      />
    </SvgWrapper>
  );
};

const FixedDepositIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 16.5L3 19.44V11H6M11 14.66L9.43 13.32L8 14.64V7H11M16 13L13 16V3H16M18.81 12.81L17 11H22V16L20.21 14.21L13 21.36L9.53 18.34L5.75 22H3L9.47 15.66L13 18.64"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

const GuaranteeReportIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 1.5V6.75C12.75 7.34674 12.9871 7.91903 13.409 8.34099C13.831 8.76295 14.4033 9 15 9H20.25V20.25C20.25 20.8467 20.0129 21.419 19.591 21.841C19.169 22.2629 18.5967 22.5 18 22.5H6C5.40326 22.5 4.83097 22.2629 4.40901 21.841C3.98705 21.419 3.75 20.8467 3.75 20.25V3.75C3.75 3.15326 3.98705 2.58097 4.40901 2.15901C4.83097 1.73705 5.40326 1.5 6 1.5H12.75ZM14.25 1.58775V6.75C14.25 6.94891 14.329 7.13968 14.4697 7.28033C14.6103 7.42098 14.8011 7.5 15 7.5H20.1623C20.057 7.13355 19.8603 6.79986 19.5907 6.53025L15.2197 2.16C14.9502 1.89014 14.6165 1.69323 14.25 1.58775ZM12.75 15.75C12.75 15.5511 12.671 15.3603 12.5303 15.2197C12.3897 15.079 12.1989 15 12 15C11.8011 15 11.6103 15.079 11.4697 15.2197C11.329 15.3603 11.25 15.5511 11.25 15.75V18.75C11.25 18.9489 11.329 19.1397 11.4697 19.2803C11.6103 19.421 11.8011 19.5 12 19.5C12.1989 19.5 12.3897 19.421 12.5303 19.2803C12.671 19.1397 12.75 18.9489 12.75 18.75V15.75ZM8.25 9C8.05109 9 7.86032 9.07902 7.71967 9.21967C7.57902 9.36032 7.5 9.55109 7.5 9.75V18.75C7.5 18.9489 7.57902 19.1397 7.71967 19.2803C7.86032 19.421 8.05109 19.5 8.25 19.5C8.44891 19.5 8.63968 19.421 8.78033 19.2803C8.92098 19.1397 9 18.9489 9 18.75V9.75C9 9.55109 8.92098 9.36032 8.78033 9.21967C8.63968 9.07902 8.44891 9 8.25 9ZM16.5 12.75C16.5 12.5511 16.421 12.3603 16.2803 12.2197C16.1397 12.079 15.9489 12 15.75 12C15.5511 12 15.3603 12.079 15.2197 12.2197C15.079 12.3603 15 12.5511 15 12.75V18.75C15 18.9489 15.079 19.1397 15.2197 19.2803C15.3603 19.421 15.5511 19.5 15.75 19.5C15.9489 19.5 16.1397 19.421 16.2803 19.2803C16.421 19.1397 16.5 18.9489 16.5 18.75V12.75Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};
const GuaranteeSummaryIcon = ({
  color,
  width,
  height,
  stroke,
  strokeWidth,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 3C1 1.89543 1.89543 1 3 1H19C20.1046 1 21 1.89543 21 3V8.43447C21 9.60787 19.4936 10.3385 18.3657 10.0146C17.3894 9.73423 16.3624 9.67781 15.3612 9.84956C14.36 10.0213 13.4105 10.4168 12.5835 11.0066C11.7564 11.5963 11.0731 12.3652 10.5846 13.2557C10.096 14.1463 9.81469 15.1357 9.76168 16.1501C9.70867 17.1645 9.8853 18.1778 10.2784 19.1145C10.6715 20.0511 11.2709 20.887 12.032 21.5598C12.3966 21.8821 12.1261 23 11.6395 23H2.65843C1.7425 23 1 22.2575 1 21.3416V3ZM13.5 6C13.5 6.55228 13.0523 7 12.5 7H5C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5H12.5C13.0523 5 13.5 5.44772 13.5 6ZM10.5 10.5C10.5 11.0523 10.0523 11.5 9.5 11.5H5C4.44772 11.5 4 11.0523 4 10.5C4 9.94771 4.44772 9.5 5 9.5H9.5C10.0523 9.5 10.5 9.94771 10.5 10.5ZM16.5 13.75C15.7707 13.75 15.0712 14.0397 14.5555 14.5555C14.0397 15.0712 13.75 15.7707 13.75 16.5C13.75 17.2293 14.0397 17.9288 14.5555 18.4445C15.0712 18.9603 15.7707 19.25 16.5 19.25C17.2293 19.25 17.9288 18.9603 18.4445 18.4445C18.9603 17.9288 19.25 17.2293 19.25 16.5C19.25 15.7707 18.9603 15.0712 18.4445 14.5555C17.9288 14.0397 17.2293 13.75 16.5 13.75ZM11.25 16.5C11.2502 15.6901 11.4378 14.8912 11.7981 14.1658C12.1584 13.4404 12.6816 12.8082 13.3269 12.3187C13.9721 11.8292 14.7219 11.4956 15.5175 11.344C16.3131 11.1924 17.133 11.227 17.9131 11.445C18.6931 11.663 19.4121 12.0585 20.0139 12.6006C20.6156 13.1427 21.0838 13.8167 21.3818 14.5698C21.6798 15.3229 21.7994 16.1348 21.7315 16.9418C21.7053 17.2522 21.6517 17.5586 21.5718 17.8576C21.346 18.7018 21.4244 19.6564 22.0423 20.2743L22.5 20.732C22.9882 21.2202 22.9882 22.0118 22.5 22.5C22.0118 22.9882 21.2202 22.9882 20.732 22.5L20.2745 22.0425C19.6566 21.4246 18.7017 21.3462 17.8576 21.5722C17.4438 21.683 17.0163 21.7431 16.5843 21.7501C15.6533 21.765 14.735 21.5321 13.9236 21.0751C13.1123 20.6182 12.4371 19.9536 11.9672 19.1496C11.4974 18.3457 11.2499 17.4312 11.25 16.5Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};

export {
  FaciltyIcon,
  LoanIcon,
  LOCIcon,
  RateIcon,
  UserIcon,
  MasterDataIcon,
  NavNotificationIcon,
  LogOutIcon,
  DashboardIcon,
  MISPortalIcon,
  DataUploadIcon,
  FixedDepositIcon,
  GuaranteeReportIcon,
  GuaranteeSummaryIcon,
};
